module.exports = __webpack_public_path__ + "static/media/summary-pay.3a84c175.svg";